import { css } from '@linaria/core';

/** Used for short, important text or numerals, like brand content. */
export const display: string = css`
  @layer cb {
    font: var(--cb-font-display);
  }
`;

/** Used for page headings, like profile or settings. */
export const largeTitle: string = css`
  @layer cb {
    font: var(--cb-font-large-title);
  }
`;

/** Used for page headings, like profile or settings. */
export const title: string = css`
  @layer cb {
    font: var(--cb-font-title);
  }
`;

/** Used to introduce new sections or in large components, like modals. */
export const headline: string = css`
  @layer cb {
    font: var(--cb-font-headline);
  }
`;

/** Used to introduce subsections or in small components like banners. */
export const subheadline: string = css`
  @layer cb {
    font: var(--cb-font-subheadline);
  }
`;

/** Default size for reading text. */
export const body: string = css`
  @layer cb {
    font: var(--cb-font-body);
  }
`;

/** Used to style field labels or to emphasize text. It pairs with Body. */
export const bodyLabel: string = css`
  @layer cb {
    font: var(--cb-font-body-label);
  }
`;

/** Use for text links inside a paragraph or for standalone text. It pairs with Body. */
export const bodyLink: string = css`
  @layer cb {
    font: var(--cb-font-body);
    text-decoration: underline;
  }
`;

/** Used to style interactive elements, like buttons and chips. */
export const bodyMedium: string = css`
  @layer cb {
    font: var(--cb-font-body-medium);
  }
`;

/** Used for short paragraph or helper text, like captions or metadata. */
export const caption: string = css`
  @layer cb {
    font: var(--cb-font-caption);
  }
`;

/** Used to style field labels or to emphasize text. It pairs with Caption. */
export const captionLabel: string = css`
  @layer cb {
    font: var(--cb-font-caption-label);
  }
`;

/** Use for text links inside a paragraph or for standalone text. It pairs with Caption. */
export const captionLink: string = css`
  @layer cb {
    font: var(--cb-font-caption);
    text-decoration: underline;
  }
`;

/** Used to style interactive elements, like buttons and chips. */
export const captionMedium: string = css`
  @layer cb {
    font: var(--cb-font-caption-medium);
  }
`;

/** Used for helper text or legal copy, like text that appears below an input field. */
export const footnote: string = css`
  @layer cb {
    font: var(--cb-font-footnote);
  }
`;

/** Used to style field labels or to emphasize text. It pairs with Footnote. */
export const footnoteLabel: string = css`
  @layer cb {
    font: var(--cb-font-footnote-label);
  }
`;

/** Use for text links inside a paragraph or for standalone text. It pairs with Footnote. */
export const footnoteLink: string = css`
  @layer cb {
    font: var(--cb-font-footnote);
    text-decoration: underline;
  }
`;

/** Used to style interactive elements, like badges. */
export const footnoteMedium: string = css`
  @layer cb {
    font: var(--cb-font-footnote-medium);
  }
`;
